<div class="setup-container">
  <img src="assets/images/chatta-white.png" class="logo" alt="">

  <h1 class="setup-title">{{ title }}</h1>

  <h2 class="setup-subtitle">{{ subTitle }}</h2>

  @if (showOk) {
    <img src="assets/images/ok_button_white.png" class="ok-button">
  }
</div>
